import { render } from "./DisconnectExchangeAlert.vue?vue&type=template&id=6fd5cfd7"
import script from "./DisconnectExchangeAlert.vue?vue&type=script&lang=js"
export * from "./DisconnectExchangeAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__